//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    suggestedUsers: {
      type: Array,
      default: () => [],
    },
    selectedUsers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isAllSuggestedUsersSelected: false,
      selectedUsersList: [],
    }
  },
  computed: {
    suggestedUsersList() {
      return this.suggestedUsers.map((user) => ({
        ...user,
        selected: this.selectedUsers.some(
          (selectedUser) => selectedUser.id === user.id
        ),
      }))
    },
  },
  watch: {
    selectedUsers: {
      handler() {
        this.syncSelectedUsers()
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.updateSelectAllCheckbox()
  },
  methods: {
    syncSelectedUsers() {
      this.selectedUsersList = this.selectedUsers.map((user) => ({
        ...user,
        selected: this.selectedUsers.some(
          (selectedUser) => selectedUser.id === user.id
        ),
      }))
      this.updateSelectAllCheckbox()
    },
    updateSelectAllCheckbox() {
      if (
        this.suggestedUsersList > 0 &&
        this.suggestedUsersList.filter((user) => user.selected).length ===
          this.suggestedUsersList.length
      ) {
        this.isAllSuggestedUsersSelected = true
      } else {
        this.isAllSuggestedUsersSelected = false
      }
    },
    pushOrPopSelectedUsers(user, selected) {
      if (selected) {
        !this.selectedUsersList.includes(user) &&
          this.selectedUsersList.push({
            ...user,
            name: `${user.names} ${user.lastnames}`,
          })
      } else {
        const index = this.selectedUsersList.findIndex(
          (selectedUser) => selectedUser.id === user.id
        )

        if (index > -1) {
          this.selectedUsersList.splice(index, 1)
        }
      }

      this.updateSelectAllCheckbox()
      this.$emit('selected-users', this.selectedUsersList)
    },
    handleSelectAll(selected) {
      this.suggestedUsersList.forEach((user) => {
        user.selected = selected
        this.pushOrPopSelectedUsers(user, selected)
      })
    },
    handleSelectUser({ user, selected }) {
      user.selected = selected
      this.pushOrPopSelectedUsers(user, selected)
    },
  },
}
